import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { isAnalyticsEligible } from './utils/analyticsEligibility';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
let analytics;
let analyticsInitPromise = null;

export const initAnalytics = async () => {
  if (!isAnalyticsEligible()) {
    return null;
  }

  if (analytics) {
    return analytics;
  }

  if (!analyticsInitPromise) {
    analyticsInitPromise = import('firebase/analytics')
      .then(({ getAnalytics }) => {
        if (!analytics) {
          analytics = getAnalytics(app);
        }

        return analytics;
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('Analytics initialisation skipped:', error);
        }

        return null;
      })
      .finally(() => {
        analyticsInitPromise = null;
      });
  }

  return analyticsInitPromise;
};

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export { analytics };
export default app;
